import React, { useState, useEffect } from "react";
import axios from "axios";

const API_BASE_URL = "https://server.ananikaet.com"; // Base API URL

const Training = () => {
  const [caregivers, setCaregivers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchCaregivers = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/caregivers/registrations`);
        setCaregivers(response.data);
        setLoading(false);
      } catch (err) {
        setError("Failed to load caregiver data.");
        setLoading(false);
      }
    };

    fetchCaregivers();
  }, []);

  return (
    <div className="container mx-auto px-4 py-8 lg:ml-64"> {/* Adjust margin for sidebar */}
      <h2 className="text-3xl font-bold text-blue-800 mb-8 text-center">Caregiver Registrations</h2>

      {loading ? (
        <p className="text-center text-gray-600 text-lg">Loading data...</p>
      ) : error ? (
        <p className="text-center text-red-600 text-lg">{error}</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {caregivers.map((caregiver) => (
            <div
              key={caregiver._id}
              className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow duration-300"
            >
              <h3 className="text-xl font-semibold text-blue-700 mb-4">{caregiver.fullName}</h3>

              <div className="space-y-2 text-gray-700">
                <p><span className="font-medium">Gender:</span> {caregiver.gender}</p>
                <p><span className="font-medium">Date of Birth:</span> {new Date(caregiver.dateOfBirth).toLocaleDateString()}</p>
                <p><span className="font-medium">Phone:</span> {caregiver.phoneNumber}</p>
                <p><span className="font-medium">Email:</span> {caregiver.email || "N/A"}</p>
                <p><span className="font-medium">Location:</span> {caregiver.city}, {caregiver.region} (Wereda {caregiver.wereda})</p>
                <p><span className="font-medium">Education Level:</span> {caregiver.educationLevel}</p>
                <p><span className="font-medium">Health Background:</span> {caregiver.healthBackground ? "Yes" : "No"}</p>
              </div>

              <div className="mt-6 space-y-2">
                {caregiver.paymentSlip && (
                  <a
                    href={`${API_BASE_URL}/${caregiver.paymentSlip}`}
                    className="block w-full text-center py-2 px-4 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors duration-300"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📄 Download Payment Slip
                  </a>
                )}
                {caregiver.pdfFile && (
                  <a
                    href={`${API_BASE_URL}/${caregiver.pdfFile}`}
                    className="block w-full text-center py-2 px-4 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors duration-300"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📑 Download PDF File
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Training;
